//jshint ignore:start
(function () {
    'use strict';
    var app = angular.module('imAnalytics');

    app
        .directive('imProductClick', ['PRODUCT_CLICK', '$q', 'imCommonService', 'imDataService',
            'imEventService', 'imProductDataService', 'imObjectData', 'imProductService', '$window','logger', imProductClick]);

    function imProductClick(PRODUCT_CLICK, $q, imCommonService, imDataService,
        imEventService, imProductDataService, imObjectData, imProductService, $window, logger) {

        return {
            restrict: 'A',
            link: link,
            scope: {
                product: '=',
                color: '=',
                position: '=',
                list: '@',
                mediaclick: '='
            }
        };
        
        //TODO Refactor
        function getData(productInfo, linktype) {
            var cf, category, action, label, customData, product;
            label = productInfo.partNumberColor;
            action = 'ver_vista_rapida_producto';
            cf = 'catalogo';
            product = imObjectData.getProductData(productInfo);
            if(imDataService.isSearch()){
                action = 'ver_producto';
                category = 'buscador';
                customData = { 
                    product: product,
                    photo: imObjectData.getPhotoData(linktype) 
                };
            }else if (document.getElementsByClassName('bundle-product-page').length > 0) {
                category = 'ficha_look';
                label = inditex.getSessionStorage('lookRef') + '-' + productInfo.partNumberColor;
                customData = {
                    product: product,
                    photo: imObjectData.getPhotoData(linktype),
                    look: imObjectData.getLookData(inditex.getSessionStorage('lookRef'))
                };
            } else if (inditex.iPage === 'ItxProductPage' && imDataService.isBundle()) {
                category = 'ficha_bundle';
                label = inditex.getSessionStorage('bundleRef') + '-' + productInfo.partNumberColor;
                customData = {
                    product: product,
                    photo: imObjectData.getPhotoData(linktype),
                    look: imObjectData.getLookData(undefined, inditex.getSessionStorage('bundleRef'))
                };
            } else if (inditex.iPage === 'ItxCheckoutPage') {
                cf = 'checkout';
                category = 'resumen_compra';
                customData = { product: product };
            } else if (inditex.iPage === 'ItxShopCartPage') {
                cf = 'checkout';
                category = 'cesta';
                !productInfo.isRelated ? action = 'ver_vista_rapida_producto' : action = 'ver_vista_rapida_producto_cross';
                customData = { product: product };
            } else if (angular.element('.mini-shopcart.open').length > 0) {
                cf = 'checkout';
                category = 'minicesta';
                action = 'ver_producto';
                customData = { product: product };
            } else if (document.getElementById('mini-wishlist')){
                cf = 'catalogo';
                category = 'miniwishlist';
                action = 'ver_producto';
                customData = { product: product };
            } else if (document.getElementById('product-navigation')) {
                category = 'ficha_producto';
                action = 'ver_vista_rapida_producto_cross';
                customData = { product: product };
            } else if (inditex.iPage === 'ItxHomePage') {
                var section = imObjectData.getSection();           
                category = 'home' + section;
                action = 'ver_producto';
            
            } else {
                category = 'parrilla';
                if (productInfo.gridElemType == 'BUNDLE') {
                    action = 'ver_bundle';
                    label = inditex.getSessionStorage('bundleRef');
                    customData = {
                        look: imObjectData.getLookData(undefined, inditex.getSessionStorage('bundleRef'))
                    };    
                } else {
                    action = 'ver_producto';
                    customData = {
                        product: product,
                        photo: imObjectData.getPhotoData(linktype),
                        category: imObjectData.getCategoryData(productInfo)
                    };
                }
            }
            var dataObject = {
                eventData: imObjectData.getEventData(cf, category, action, label),
                customData: customData
            };

            return dataObject;
        }

        function parseProduct(product, colorIndex, position) {

            var promise = function(resolve) {
                imProductDataService.getProductInfo(product, null, colorIndex)
                    .then(function(infoObject) {
                        var productObject = [{
                            name: infoObject.name,
                            id: infoObject.id,
                            category: infoObject.category,
                            position: typeof(position) !== 'undefined' ? parseInt(position) + 1 : undefined,
                            dimension96: infoObject.color || infoObject.dimension96,
                            dimension99: infoObject.dimension99,
                            dimension100:infoObject.dimension100,
                            dimension101:infoObject.dimension101,
                            dimension117:infoObject.dimension117,
                            dimension109:infoObject.section || infoObject.dimension109,
                            dimension111: infoObject.family || infoObject.dimension111,
                            dimension113:infoObject.subfamily || infoObject.dimension113,
                            price: infoObject.price,
                            partNumberColor: infoObject.partNumberColor,
                            key: infoObject.key,
                            isRelated: infoObject.isRelated,
                            gridElemType: infoObject.gridElemType,
                            dimension29: infoObject.isCustomizable
                        }];
                        resolve(productObject);
                    });
            };

            return $q(promise);
        }

        function link(scope, element) {
            element.on('mousedown', function (e) {
                if (e.which === 1 || e.which === 2) {
                    var ecomerceObject = PRODUCT_CLICK;
                    var list; 
                    if(scope.list === 'minicesta'){
                        inditex.setSessionStorage('imList', 'minicesta');
                        list = undefined;
                    } 
                    else {
                        var list = imDataService.getList(scope.product);
                        inditex.setSessionStorage('imList', list);
                    }
                    if (/lookbook_.+/.test(list)) {
                        //position add lookbook
                        if (document.getElementsByClassName('bundle-product-page').length > 0 && $window.imAnalytics.visibleBundlesJSON) {
                            $window.imAnalytics.visibleBundlesJSON.find(function(item) {
                                if (item.id === $window.imAnalytics.bundleId) {
                                    item.bundleProductSummaries.find(function(item, index) {
                                        if (item.id === scope.product.id) {
                                            return scope.position = index;
                                        }
                                    });
                                }
                            });

                        }
                    }{}
                        logger.log('-> Analytics pageName: feature-product');

                    ecomerceObject.ecommerce.currencyCode = imCommonService
                        .replaceValue(ecomerceObject.ecommerce.currencyCode, imDataService.getCurrencyCode());
                    ecomerceObject.ecommerce.click.actionField.list = list;
                    if (scope.product.gridElemType != 'BUNDLE' || inditex.iPage == 'ItxProductPage'){
                        parseProduct(scope.product, scope.color ? scope.color : 0, scope.position).then(function(productInfo) {
                            var dataObject = getData(productInfo[0], getLinktype(scope));

                            ecomerceObject.ecommerce.click.products = imCommonService
                                .replaceProduct(ecomerceObject.ecommerce.click.products, productInfo);

                            imEventService
                                .analyticsEvent([dataObject], ecomerceObject);
                        });
                    } else {
                        imProductDataService.getBundleInfo(scope.product).then(function (productInfo) {
                            var dataObject = getData(scope.product, getLinktype(scope));

                            ecomerceObject.ecommerce.click.products = imCommonService
                                .replaceProduct(ecomerceObject.ecommerce.click.products, imProductService.parseEcommerceProduct(productInfo));

                            imEventService
                                .analyticsEvent([dataObject], ecomerceObject);
                        });
                    }
                }

            });
        }
        function getLinktype(scope) {
            if (scope.mediaclick === 'foto') {
                if(scope.product.config && scope.product.config.isDoubleBox){
                    return 'foto_doble';
                }                
            }
            return scope.mediaclick;
        }
    }



    app
        .directive('imScrollView', ['$timeout', 'hgScrollEvent', '$q', 'imImpressionService', imScrollView]);

    function imScrollView($timeout, hgScrollEvent, $q, imImpressionService) {

        hgScrollEvent.scrollstop();
        var first = true;

        return {
            scope: {
                useParent: '@',
                type: '@',
                term: '=',
                number: '=',
                list: '@',
                isPage: '=',
                isSearch: '='
            },
            controller: ['$scope', '$element', imScrollViewController],
            restrict: 'A',
        };

        function imScrollViewController($scope, $element) {
            $scope.sendType = $scope.type || null;
            
            if (!('elements' in $scope)) {
                $scope.elements = [];
            }

            if (first) {
                hgScrollEvent.scrollstop($element);
                first = false;
            }

            $scope.sending = 0;
            $scope.len = -1;
            $scope.isNoReload = false;

            this.addElement = function (product, position, search, lookbook, colorIndex) {
                $scope.search = search;
                if (lookbook || (product.bundleProductSummaries && product.bundleProductSummaries.length > 0)) {
                        product.bundleProductSummaries.map(function (e, index) {
                            $scope.elements.push({ product: e, position: index });
                        });
                } else {
                    $scope.elements.push({ product: product, position: position , colorIndex: colorIndex});
                }
            };

            $scope.$on('imReloadedCategory', function () {
                $scope.isNoReload = true;
                window.noReloadLen = -1;
                $scope.sending = 0;
            });

            this.sendEvent = function (sendType) {
                if ($scope.sendType !== null) {
                    sendType = $scope.sendType;
                }

                if ($scope.elements.length !== 0) { //Send only when got elements
                    if ($scope.isPage === true) { //Evitar enviar impresiones sin pageview anterior
                        sendType = false;
                        $scope.isPage = false;
                    }
                    imImpressionService
                        .sendImpression($scope, sendType);
                }
                $scope.elements = [];
            };

            this.resetElements = function () {
                $scope.elements = [];
            };

            this.isAllSending = function() {
                $scope.sending++;
                if ($scope.isNoReload && !$scope.isSearch) {
                    return ((window.noReloadLen - $scope.sending) === -1);
                }
                return (($scope.len - $scope.sending) === -1);
            };

            this.setLength = function (len) {               
                if (len > $scope.len) {
                    $scope.len = len;                  
                }
            };

            this.resetLength = function () {
                $scope.isNoReload = false; //tema menu lateral 
                window.noReloadLen = undefined; //tema menu lateral
                $scope.sending = 0;
                this.resetElements();
            };

            this.getParent = function () {
                return ($scope.useParent) ? $element : null;
            };
        }
    }

    app
        .directive('imDisable', ['DEBUG', imDisable]);
    function imDisable(DEBUG) {
        return {
            priority: 100000,
            compile: compile,
        };

        function compile(element, attrs) {
            var exists = true;
            var idsArray = [];
            if (typeof (attrs.enabled) === 'string') {
                idsArray = attrs.enabled.split(',');
                exists = idsArray.some(function (item) {
                    return document.getElementById(item);
                });
            }

            if (typeof (attrs.disable) === 'string') {
                idsArray = attrs.disable.split(',');
                exists = !idsArray.some(function (item) {
                    return document.getElementById(item);
                });
            }

            if (!exists) {
                var hasDirective = element[0].querySelectorAll('[' + attrs.directive + ']');
                [].forEach.call(hasDirective, function (el) {
                    DEBUG('Removing ' + attrs.directive);
                    el.removeAttribute(attrs.directive);
                });
            }
        }
    }

    app
        .directive('imScrollViewProduct', ['DEBUG', '$window', '$timeout', imScrollViewProduct]);
    function imScrollViewProduct(DEBUG, $window, $timeout) {
        return {
            restrict: 'A',
            require: '^imScrollView',
            link: link,
            scope: {
                lookbook: '=',
                search: '=',
                product: '=',
                position: '=',
                colorIndex: '='
            }
        };

        function isElementVisible(element, controller) {
            var parentElement = controller.getParent();

            var elemTop = element[0].getBoundingClientRect().top;
            var elemLeft = element[0].getBoundingClientRect().left;
            var elemRight = element[0].getBoundingClientRect().right;
            var elemHeightPartial = element[0].getBoundingClientRect().height * 0.6;
            var elemBottom = element[0].getBoundingClientRect().bottom;

            var contentElement = {};
            var windowSize = {};
            var isParentVisible = true;

            windowSize.right = $window.innerWidth;
            windowSize.bottom = $window.innerHeight + elemHeightPartial;
            windowSize.top = 0 - elemHeightPartial;
            windowSize.left = 0;

            if (parentElement) {
                contentElement.right = parentElement[0].getBoundingClientRect().right;
                contentElement.bottom = parentElement[0].getBoundingClientRect().bottom + elemHeightPartial;
                contentElement.top = parentElement[0].getBoundingClientRect().top - elemHeightPartial;
                contentElement.left = parentElement[0].getBoundingClientRect().left;

                isParentVisible = (contentElement.top >= windowSize.top)
                    && (contentElement.bottom <= windowSize.bottom)
                    && (contentElement.left >= windowSize.left && contentElement.right <= windowSize.right);
            } else {
                contentElement = windowSize;
            }

            var isVisible = (elemTop || elemBottom || elemLeft || elemRight)
                && (elemTop >= contentElement.top)
                && (elemBottom <= contentElement.bottom)
                && (elemLeft >= contentElement.left && elemRight <= contentElement.right);

            return isVisible && isParentVisible;
        }

        function validateSend(controller, scroll) {
            var allSending = controller.isAllSending();
            if (allSending) {
                if (scroll) {
                    controller.sendEvent(false);
                } else {
                    controller.sendEvent(true);
                }
                controller.resetLength();
            }
        }

        function sendElement(scope, element, controller, scroll) {
            var isVisible = isElementVisible(element, controller);
            if (isVisible) {
                controller.addElement(scope.product, scope.position, scope.search, scope.lookbook, scope.colorIndex);
            }
            window.noReloadLen++;

            $timeout(function () {
                validateSend(controller, scroll);
            }, 1000);

            element.unbind('load');
        }

        function getLast(scope, controller) {
            var parent = scope;
            while (parent && !('$last' in parent)) {
                parent = parent.$parent;
            }
            controller.setLength(parent.$index);
            return parent.$last;
        }

        function link(scope, element, attrs, controller) {
            getLast(scope, controller);
            element.bind('load', function () {
                sendElement(scope, element, controller, true);
            });
            /**
             * This function avoid to impresions doesnt work if not load.
             */
            element.bind('error', function () {
                DEBUG('Image cannot be loaded, Skiping');
                validateSend(controller, true);
                element.unbind('load');
            });

            scope.$on('scrollstop', function () {
                getLast(scope, controller);
                sendElement(scope, element, controller, false);
            });
       }
    }

    app
        .directive('imAddCart', ['ADD_CART', '$q', 'imCommonService', 'imDataService', 'imEventService',
            'imProductService', 'imProductDataService', 'imObjectData','$window', imAddCart]);
    function imAddCart(ADD_CART, $q, imCommonService, imDataService, imEventService,
        imProductService, imProductDataService, imObjectData, $window) {
        return {
            scope: {
                color: '=',
                size: '=',
                position: '=',
                product: '=',
                list: '='
            },
            link: link,
            restrict: 'A'
        };
        function parseProduct(product, color, sizeSku, position) {
            var promise = function (resolve) {
                imProductDataService.getProductInfo(product, null, color.id, sizeSku)
                    .then(function (infoObject) {
                        var productObject = [{
                            name: infoObject.name,
                            id: infoObject.id,
                            key: infoObject.key,
                            category: infoObject.category,
                            position: position,
                            quantity: 1,
                            dimension96: infoObject.color,
                            dimension97: infoObject.size,
                            dimension99: infoObject.dimension99,
                            dimension100:infoObject.dimension100,
                            dimension101:infoObject.dimension101,
                            dimension117:infoObject.dimension117,
                            dimension109:infoObject.section,
                            dimension111: infoObject.family,
                            dimension113:infoObject.subfamily,
                            price: infoObject.price,
                            partNumber: infoObject.partNumber,
                            talla: infoObject.size,                            
                            color: infoObject.color,
                            productState: infoObject.productState,
                            claseProducto: infoObject.claseProducto,
                            dimension29: infoObject.isCustomizable
                        }];
                        resolve(productObject);
                    });
            };
            return $q(promise);
        }

        function getDataFromCategory(productInfo) {
            var category, action, lookReference;
            var label = productInfo.partNumber;
            action = 'anadir_producto_cesta';
            if (imProductService.isLookbook()) {
                if (imProductService.isProductDialog()) {
                    category = 'lookbook_vista_rapida_producto';
                } else {
                    category = 'ficha_look';
                }
                lookReference = inditex.getSessionStorage('lookRef');
                label = lookReference + '-' + productInfo.partNumber;
            } else {
                category = 'parrilla';
                if (imProductService.isProductDialog()) {
                    category = 'vista_rapida_producto';
                }
            }

            return {
                category: category,
                action: action,
                lookReference: lookReference,
                label: label
            };
        }

        function getDataFromProduct(productInfo) {
            var category, action, lookReference;
            var label = productInfo.partNumber;
            var isBundle = $window.imAnalytics && $window.imAnalytics.isBundleBean;
            var refBundle;

            if (isBundle) {
                refBundle = inditex.getSessionStorage('bundleRef') + '-';
                label = refBundle + label;
                refBundle = refBundle.replace('-', '');
            }

            if (productInfo.key === inditex.iProductId) {
                category = 'ficha_producto';
                action = 'anadir_producto_cesta';
            } else if ((productInfo.key !== inditex.iProductId)
                && !imProductService.isProductDialog()) {
                category = 'ficha_producto';
                action = 'anadir_producto_cross_cesta';
                if (isBundle) {
                    category = 'ficha_bundle';
                    action = 'anadir_producto_cesta';

                }
            } else if ((productInfo.key !== inditex.iProductId)
                && imProductService.isProductDialog()) {
                category = 'vista_rapida_producto_cross';
                action = 'anadir_producto_cesta';
                if (isBundle) {
                    category = 'bundle_vista_rapida_producto';
                }
            }
            return {
                category: category,
                action: action,
                lookReference: lookReference,
                bundleReference:refBundle,
                label: label
            };
        }
        function getDataFromCart(productInfo) {
            var category, action, lookReference;
            var label = productInfo.partNumber;
            if (!imProductService.isProductDialog()) {
                category = 'cesta';
                action = 'anadir_producto_cross_cesta';
            } else if (imProductService.isProductDialog()) {
                category = 'cesta_vista_rapida_producto';
                action = 'anadir_producto_cesta';
            }
            return {
                category: category,
                action: action,
                lookReference: lookReference,
                label: label
            };
        }

        function getData(productInfo) {
            var data = {};
            switch (inditex.iPage) {
                case 'ItxCategoryPage':
                    data = getDataFromCategory(productInfo);
                    break;
                case 'ItxProductPage':
                    data = getDataFromProduct(productInfo);
                    break;

                case 'ItxShopCartPage':
                    data = getDataFromCart(productInfo);
                    break;

                case 'ItxCheckoutPage':
                    data = {
                        category: 'resumen_vista_rapida_producto',
                        action: 'anadir_producto_cesta',
                        label: productInfo.partNumber,
                        lookReference: undefined,
                    };
                break;
            }
            if (imDataService.isSearch()) {
                //Eventos buscador
                data.category = 'buscador';
                data.action = 'anadir_producto_cesta';
                data.label = productInfo.partNumber;
            }

            var dataObject = {
                eventData: imObjectData.getEventData('checkout', data.category, data.action, data.label),
                customData: {
                    product: imObjectData.getProductData(productInfo),
                    look: imObjectData.getLookData(data.lookReference,data.bundleReference)
                }
            };
            return [dataObject];
        }

        function link(scope, element) {
            element.on('click', function () {
                //Se deben excluír los add de fitAnalytics.               
                if (arguments[1] !== 'fitAnalytics') {
                    if (scope.size) {
                        var ecomerceObject = ADD_CART;
                        ecomerceObject.ecommerce.currencyCode = imCommonService
                            .replaceValue(ecomerceObject.ecommerce.currencyCode, imDataService.getCurrencyCode());
                        ecomerceObject.ecommerce.add.actionField.list = imCommonService
                            .replaceValue(ecomerceObject.ecommerce.add.actionField.list, scope.list);
                        var position;
                        if (typeof(scope.position) !== 'undefined') {
                            //position add lookbook
                            if (document.getElementsByClassName('bundle-product-page').length > 0 && $window.imAnalytics.visibleBundlesJSON) {
                                $window.imAnalytics.visibleBundlesJSON.find(function(item, index) {
                                    if (item.id === $window.imAnalytics.bundleId) {
                                        item.bundleProductSummaries.find(function(item, index) {
                                            if (item.id === scope.product.id) {
                                                return position = index + 1;
                                            };
                                        });
                                    }
                                });

                            } else {
                                position = scope.position;
                            }
                        } else {
                            position = imProductService.getPosition();
                        }
                        if (imDataService.isSearch()) {
                            ecomerceObject.ecommerce.add.actionField.list = 'buscador';
                        }
                        if (inditex.iPage === 'ItxCategoryPage' && (!imDataService.isSearch() && scope.list === 'buscador')) {
                            ecomerceObject.ecommerce.add.actionField.list = imDataService.getList();
                        }
                        if (imProductService.isProductDialog() && !imDataService.isSearch()) {
                            // casuística popups
                            position = undefined;
                            ecomerceObject.ecommerce.add.actionField.list = undefined;
                        }
                        parseProduct(scope.product, scope.product.activeDetail.colors[scope.color], scope.size.sku, position)
                            .then(function(productInfo) {
                                var dataObject = getData(productInfo[0]);
                                productInfo.map(function(item) {
                                    delete item.partNumber;
                                    delete item.color;
                                    delete item.talla;
                                });
                                ecomerceObject.ecommerce.add.products = imCommonService
                                    .replaceProducts(ecomerceObject.ecommerce.add.products, productInfo);
                                imEventService
                                    .analyticsEvent(dataObject, ecomerceObject);
                            });
                    }
                }
            });
        }
    }

    app
        .directive('imRemoveCart', ['REMOVE_CART', 'imCommonService', 'imEventService', imRemoveCart]);
    function imRemoveCart(REMOVE_CART, imCommonService, imEventService) {
        return {
            link: link,
            scope: {
                currencyCode: '@',
                product: '=',
                data: '=',
            },
            restrcit: 'A',
        };

        function link(scope, element) {
            element.on('click', function () {
                var ecomerceObject = REMOVE_CART;

                ecomerceObject.ecommerce.currencyCode = imCommonService
                    .replaceValue(ecomerceObject.ecommerce.currencyCode, scope.currencyCode);
                ecomerceObject.ecommerce.remove.products = imCommonService
                    .replaceProducts(ecomerceObject.ecommerce.remove.products, scope.product);

                imEventService
                    .analyticsEvent(scope.data, ecomerceObject);
            });
        }
    }

    app
        .directive('imPopupView', ['imEventService', 'imObjectData', imPopupView]);
    function imPopupView(imEventService, imObjectData) {
        // TODO: COuld change by attrs, not isolate scope
        return {
            link: link,
            scope: {
                cf: '@',
                category: '@',
                action: '@',
                label: '@',
            },
            priority: 10
        };

        function link(scope, element) {
            element.on('click', function () {
                var dataObject = {
                    eventData: imObjectData
                        .getEventData(scope.cf, scope.category, scope.action, scope.label)
                };
                imEventService.popupView([dataObject]);
            });
        }
    }

    app
        .directive('imGiftPacking', ['imEventService','imObjectData' , imGiftPacking]);
    function imGiftPacking(imEventService, imObjectData) {
        // TODO: COuld change by attrs, not isolate scope
        return {
            link: link,
            priority: 10
        };

        function link(scope, element) {
            element.on('click', function () {
                var category = 'resumen_compra';
                if(inditex.iPage === 'ItxShopCartPage'){
                    category = 'cesta';
                }
                var dataObject = {
                    eventData: imObjectData
                        .getEventData('checkout', category, 'ver_opciones_regalo')
                };
                imEventService.analyticsEvent([dataObject]);
            });
        }
    }
    app
        .directive('imHideProductPage', ['imEventService', '$rootScope', imHideProductPage]);
    function imHideProductPage(imEventService, $rootScope) {
        return {
            link: link
        };

        function link(scope, element) {
            element.on('touchend', function () {
                var interval = setInterval(function () {
                    if (inditex.iPage === 'ItxCategoryPage') {
                        clearInterval(interval);
                        //Para evitar lanzar 2 veces el pageview al acceder primero a la ficha de producto y después a la parrilla. 
                        if (angular.element('.product-view-image-wrapper').length > 0) {                         
                            $rootScope.$broadcast('imHidePopup');
                        }
                    }
             }, 1000);
            })
        }
    }

    app
        .directive('imToggleProductInfo', ['imProductService', imToggleProductInfo]);
    function imToggleProductInfo(imProductService) {

        return {
            link: link,
            scope: {
                product:'=',
                type:'@'
            }
        };

        function link(scope, element) {
            element.on('click', function () {
                if ($(this).siblings('.js-show-productinfo').length===1){
                    imProductService.eventProductInfo(scope.product, scope.type);
                }
            });
        }
    }

    app
        .directive('imHomeEvent', ['imHomeService', 'imImpressionService','logger', imHomeEvent]);
    function imHomeEvent(imHomeService, imImpressionService, logger) {

        return {
            link: link,
            scope: {
                labelclick: '=',
                mediaclick: '@',
                section: '=',
                textclick: '='
            }
        };

        function getLinktype(scope) {
            if (scope.mediaclick === 'foto') {

                if (scope.product && scope.product.config && scope.product.config.isDoubleBox) {
                    return 'foto_doble';
                }
            }
            return scope.mediaclick;
        }

        function link(scope, element) {
            element.on('click', function () {
                var mediaClick = getLinktype(scope);
                var labelClick = scope.labelclick;               
                var data = scope.textclick;
                var section = scope.section || 'layout_cover_image';
                imHomeService.createEvent(section, labelClick, mediaClick);
               
                if(!labelClick){
                    logger.logError('-> Analytics pageName ERROR: this section link is not category & no pageName parameter!');
                }else{
                    if(!data){
                        logger.log('-> Analytics pageName: ', labelClick);
                    }else{
                        logger.log('-> Analytics pageName: ', data, '/', labelClick);
                    }
                        
                }
            });
        }
    }

    app
        .directive('imSelectedStore', ['imEventServiceWrapper', imSelectedStore]);
    function imSelectedStore(imEventServiceWrapper) {

        return {
            link: link,
            scope: {
                language:'='
            }
        };

        function link(scope, element) {
            element.on('click', function () {
                var interval = setInterval(function(){
                    if (inditex.iStoreJSON && inditex.iPage === 'ItxHomePage') {
                        clearInterval(interval); 
                        imEventServiceWrapper.sendBasicPageView('entrada', 'home', 'pagina_inicio');
                    }
                });
            });
        }
    }
})();
